<template>
  <gg-card>
    <gg-card-header>
      Manage Addon Domains
      <div class="float-right">
        <gg-text-field outlined
                       v-model="search"
                       append-icon="mdi-magnify"
                       single-line
                       hide-details
        />
      </div>
    </gg-card-header>
    <gg-card-text>
      <v-data-table :loading="loading"
                    :headers="headers"
                    :search="search"
                    :items="hostingAddonDomains">
        <template v-slot:item.actions="{ item }">
          <gg-btn @click="openModal(item)">
            Delete
          </gg-btn>
        </template>
      </v-data-table>
      <delete-addon-domain-modal v-if="modal"
                                 :opened="modal"
                                 :addon-domain="selectedAddon"
                                 @addondomain-deleted="reload"
                                 @close="closeModal('delete')"
      />
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import reloadable from '@/mixins/tableShouldBeReloaded'
import DeleteAddonDomainModal from './DeleteAddonDomainModal'

export default {
  name: 'AddonDomainsTable',
  components: {
    DeleteAddonDomainModal,
  },
  mixins: [reloadable],
  data () {
    return {
      search: '',
      loading: false,
      selectedAddon: null,
      modal: false,
      headers: [
        {
          text: 'Addon Domains',
          value: 'domain',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        }
      ],
    }
  },
  computed: {
    ...mapGetters({
      hostingAddonDomains: 'hostingDomains/hostingAddonDomains'
    }),
  },
  methods: {
    ...mapActions({
      getHostingAddonDomains: 'hostingDomains/getHostingAddonDomains',
      reportError: 'reportError'
    }),
    reload () {
      this.loading = true
      this.getHostingAddonDomains(this.$route.query.user).then(
        () => {
          this.loading = false
          this.$emit('table-reloaded')
        },
        error => {
          this.loading = false
          this.reportError(error)
        }
      )
    },
    openModal (addon) {
      this.modal = true
      this.selectedAddon = { ...addon }
    },
    closeModal () {
      this.modal = false
      this.selectedAddon = null
    }
  },
  created () {
    this.reload()
  }
}
</script>
